import { render, staticRenderFns } from "./QuoteHeader.vue?vue&type=template&id=4b7f73bb&scoped=true"
import script from "./QuoteHeader.vue?vue&type=script&lang=js"
export * from "./QuoteHeader.vue?vue&type=script&lang=js"
import style0 from "./QuoteHeader.vue?vue&type=style&index=0&id=4b7f73bb&prod&lang=scss&scoped=true"
import style1 from "./QuoteHeader.vue?vue&type=style&index=1&id=4b7f73bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7f73bb",
  null
  
)

export default component.exports